@if (loading()) {
  <app-loading></app-loading>
} @else if (!loading() && data && !location) {
  <app-not-found></app-not-found>
} @else if (!loading() && data && location) {
  <ng-container *transloco="let t">
    <div class="container no-container-on-mobile">
      <!-- Header -->
      <a class="m-0 p-0" [href]="'http://maps.google.com/?q=' + location.address"
        (click)="insightService.send({event: 'click', event_name: 'click_map'})" target="_blank">
        <figure class="w-full location-header m-0 p-0 cover-image">
          <img [src]="location.map" [alt]="t('cta.map_alt_img')" class="w-full h-full" draggable="false">
        </figure>
      </a>
    </div>
  
    <div class="container">
      <div class="mt-0 mb-0">
        <ul class="list-none p-0">
          <li>
            <a [style]="{'margin-top': '12px'}" (click)="insightService.send({event: 'click', event_name: 'click_map'})"
              [href]="'http://maps.google.com/?q=' + location.address"
              class="ml-3 no-underline text-color flex align-items-center" target="_blank">
              <span class="material-icons text-orange-700" aria-hidden="true">
                place
              </span>
              <div class="flex flex-column ml-4">
                <span class="text-500">{{ location.address }}</span>
                <strong class="text-500">{{ t('cta.address') }}</strong>
              </div>
            </a>
          </li>
  
          <li> <p-divider [style]="{'margin': '12px 0 12px 0'}"></p-divider></li>
  
          <li> <a (click)="insightService.send({event: 'click', event_name: 'click_phone'})"
              href="tel:{{ location.telephone }}" class="ml-3 flex align-items-center no-underline text-color">
              <span class="material-icons text-green-700" aria-hidden="true">
                call
              </span>
              <div class="flex flex-column ml-4">
                <span>
                  {{ location.telephone }}
                </span>
                <strong class="text-500">{{ t('cta.call') }}</strong>
              </div>
            </a></li>
  
          <li> <p-divider [style]="{'margin': '12px 0 12px 0'}"></p-divider></li>
  
          <li> 
            @if (location.whatsapp) {
              <a
              (click)="insightService.send({event: 'click', event_name: 'click_chat_whatsapp'})"
              class="ml-3 flex align-items-center no-underline text-color" target="_blank"
              href="https://wa.me/{{ location.whatsapp }}" target="_blank">
              <span class="material-icons text-teal-700" aria-hidden="true">
                textsms
              </span>
              <div class="flex flex-column ml-4">
                <span class="text-500">
                  {{ location.whatsapp }}
                </span>
                <strong class="text-500">{{ t('cta.whatsapp') }}</strong>
              </div>
            </a>
            }
          </li>
  
          <li>
            @if (location.whatsapp) { 
              <p-divider [style]="{'margin': '12px 0 12px 0'}"></p-divider>
            }
          </li>
  
          <li>
            @if (location.telegram) {
              <a (click)="insightService.send({event: 'click', event_name: 'click_chat_telegram'})"
                class="ml-3 flex align-items-center no-underline text-color" target="_blank"
                href="https://t.me/{{ location.telegram.split('@').join('') }}" target="_blank">
                <span class="material-icons text-blue-700" aria-hidden="true">
                  forum
                </span>
                <div class="flex flex-column ml-4">
                  <span class="text-500">
                    {{ location.telegram }}
                  </span>
                  <strong class="text-500">{{ t('cta.telegram') }}</strong>
                </div>
              </a>
            }
          </li>
          <li> 
            @if (location.telegram) {
              <p-divider [style]="{'margin': '12px 0 12px 0'}"></p-divider>
            }
          </li>
        </ul>
      </div>
  
      <div class="mt-4">
        <h2 class="text-center">{{ t('hours') }}</h2>
        <p-divider align="center">
          <span class="material-icons-outlined" aria-hidden="true" role="separator">
            schedule
          </span>
        </p-divider>
        <app-opening-hours [openingHours]="openingHours"></app-opening-hours>
  
        <!-- Location notes -->
         @if (location.notes) {
          <p class="mb-1 mt-4" [innerHTML]="location.notes | translate | safeStyle"></p>
          <p-divider styleClass="mt-4 mb-3"></p-divider>
         }
      </div>
    </div>
  
    <div class="mt-4 flex align-items-center justify-content-center">
      <p-button [label]="t('all_locations') | uppercase" (onClick)="router.navigate(['/sedi'])"></p-button>
    </div>
  </ng-container>
}
